import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2aa06ed4"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa06ed4')) {
      api.createRecord('2aa06ed4', component.options)
    } else {
      api.reload('2aa06ed4', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=2aa06ed4", function () {
      api.rerender('2aa06ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/header.vue"
export default component.exports